import React from "react";
import {Container, Link, ListItem, Stack, Typography} from "@mui/material";
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import TelegramIcon from '@mui/icons-material/Telegram';
import {useStore} from "./store";


function Footer() {
    const { settings, setSettings } = useStore();
    return (
        <footer>
            <Container sx={{mt: 4, mb: 2}}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography>© 2024 Tenishevaschool</Typography>

                    <Stack direction="row" spacing={0} fontSize={'medium'}>
                        {settings.tg && (
                            <ListItem>
                                <Link  href={settings.tg} aria-label="Telegram" target="_blank" rel="noreferrer">
                                    <TelegramIcon/>
                                </Link>
                            </ListItem>
                        )}
                        {settings.vk && (
                            <ListItem>
                                <Link href={settings.vk} aria-label="VK" target="_blank" rel="noreferrer">
                                VK
                                </Link>
                            </ListItem>
                        )}
                        {settings.phone && (
                            <ListItem>
                                <Link href={`tel:${settings.phone}`} aria-label="Phone">
                                    <PhoneIcon />
                                </Link>
                            </ListItem>
                        )}
                        {settings.email && (
                            <ListItem>
                                <Link href={`mailto:${settings.email}`} aria-label="Mail">
                                    <EmailIcon/>
                                </Link>
                            </ListItem>
                        )}
                    </Stack>

                </Stack>
            </Container>
        </footer>
    );
}

export default Footer;
